import { useMemo } from 'react'
import { toast } from 'sonner'
import type { BillingScheduleInfo } from '../../billing-schedules/types'
import { ActionDropdown } from '@shared/components/ui/action-dropdown/ActionDropdown'
import { Button } from '@shared/components/ui/button'
import { getBillingSchedulePanelActions } from '@shared/lib/actions/billing-schedule-actions'
import type { TableActionGroup } from '@shared/types/data-table'

const actions = getBillingSchedulePanelActions({}) as unknown as TableActionGroup<BillingScheduleInfo>[]

interface BillingScheduleActionsProps {
  entityInfo: BillingScheduleInfo
}

export function BillingScheduleActionsComponent({ entityInfo }: BillingScheduleActionsProps) {
  const primaryCTA = useMemo(() => {
    const status = entityInfo.status
    if (status === 'draft' || status === 'archived') return { label: 'Activate' }
    if (status === 'active') return { label: 'Pause' }
    return null
  }, [entityInfo.status])

  return (
    <div className="flex items-center gap-2">
      {primaryCTA && (
        <Button
          variant="action"
          size="action"
          onClick={() => toast.info(`${primaryCTA.label} billing schedule`)}
        >
          {primaryCTA.label}
        </Button>
      )}
      <ActionDropdown actions={actions} item={entityInfo} variant="outline" />
    </div>
  )
}
